// ==================================================================================
// PURCHASE EVENT HANDLER
// ==================================================================================

console.error(">>> Script triggered");

window.addEventListener("breeze-purchase", (event) => {
  if (!event.detail || !event.detail.data) {
    console.error("❌ Purchase event: Invalid event data - missing detail or data");
    return;
  }

  breezePurchase(event.detail);
});

function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.error("❌ Error in breezePurchase:", e);
    console.error("Stack:", e.stack);
  }
}

function merchantPurchaseCustomCode(params) {
  // Load FB Pixel SDK if not already present
  if (!window.fbq) {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

    fbq('init', '1067830763076514');
  }

  // Fire the Purchase event with order data
  fbq('track', 'Purchase', {
    value: params.totalPrice,
    currency: 'INR',
    content_type: 'product',
    order_id: params.shopOrderId
  });
}